import HeaderMain from '~/themes/base/components/shop/HeaderMain'

export default {
  mixins: [HeaderMain],
}
